/* istanbul ignore file */
import { useBaseCrudService } from 'framework/crud';
import employeeNoteValidation from './validation/employeeNoteValidation';
import { useKernelApi } from 'infrastructure/api';

export const CREATE_EMPLOYEE_NOTE = 'CREATE_NOTE';
export const UPDATE_EMPLOYEE_NOTE = 'UPDATE_NOTE';

const useEmployeeNoteService = () => {
  const { update } = useBaseCrudService({
    listResourceUrl: '/notes',
    singleResourceUrl: '/notes/:id',
    useService: useKernelApi,
  });

  return {
    getValidationSchema: () => Promise.resolve(employeeNoteValidation),
    update,
  };
};

export default useEmployeeNoteService;
